// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__25oYV","wrapper":"Notification_wrapper__32D--","close":"Notification_close__3uCao"};